import React from 'react'
import { DeleteProceedingsDialog, PrimaryCta } from 'components'

function GridDeleteProceeding({ proceedingid, proceedingname }) {
  return (
    <DeleteProceedingsDialog
      togglerComponent={PrimaryCta}
      // togglerProps={{ size: 'grid' }}
      proceedingId={proceedingid}
      proceedingName={proceedingname}
    >
      Eliminar Lote
    </DeleteProceedingsDialog>
  )
}

export const MemoizedGridDeleteProceeding = React.memo(GridDeleteProceeding)
